
import {RouteObject} from 'react-router'
import {
    Body_16_Coral_Primary_Regular_16, Title_28_Coral_Strong_emphasis_24
} from '../../../UIkit/typography/generated/typography.tsx'
import {PageWithPicture} from '@src/CommonComponents/PageWithPicture/PageWithPicture.tsx'
import {Stack} from '../../CommonComponents/Stack/Stack.tsx'
import {ErrorPage} from '@src/Layers/ErrorLayer/ErrorPage.tsx'
import {Gt} from '../../i18n/Gt.tsx'
import styles from './forgotPasswordPage.module.less'
import {ForgotPassword} from "../../../UIkit/illustrationsSvg/ForgotPassword.tsx";

export const ForgotPasswordPage = () => {
    return (
        <PageWithPicture backLink={'/login'}>
            <ForgotPassword/>
            <Stack direction={"column"} gap={16} className={styles.wrapper}>
                <Title_28_Coral_Strong_emphasis_24 style={{textAlign: 'center'}}>
                    <span className={styles.title}><Gt>Can't log in?</Gt></span>
                </Title_28_Coral_Strong_emphasis_24>
                <Body_16_Coral_Primary_Regular_16>
                    <Gt>If you can't log in, please check the following.</Gt>
                </Body_16_Coral_Primary_Regular_16>
                <ul className={styles.checklist}>
                    <li>
                        <Body_16_Coral_Primary_Regular_16>
                            <Gt>Make sure your ID and password are entered correctly. Passwords are case-sensitive.</Gt>
                        </Body_16_Coral_Primary_Regular_16>
                    </li>
                    <li>
                        <Body_16_Coral_Primary_Regular_16>
                            <Gt>An internet connection is required to log in. Please check your connection and try again.</Gt>
                        </Body_16_Coral_Primary_Regular_16>
                    </li>
                    <li>
                        <Body_16_Coral_Primary_Regular_16>
                            <Gt>If you still can't log in, please contact your administrator.</Gt>
                        </Body_16_Coral_Primary_Regular_16>
                    </li>
                </ul>
            </Stack>
        </PageWithPicture>
    )
}

export const path = 'forgot'

export const forgotPasswordRoute: RouteObject = {
    path,
    element: <ForgotPasswordPage/>,
    errorElement: <ErrorPage header={false}/>,
}
